export default __webpack_public_path__ + "img/99817ba5949c4581a20c9aa4fc50c166.svg";